import { Box } from "@mui/material";
import { Fragment } from "react";

const SampleOriginDistribution = () => {
  const data = [
    {
      title: "EU",
      percentage: "42.3%",
      number: "1,209",
      color: "#1F5C90",
    },
    {
      title: "Third countries",
      percentage: "53.1%",
      number: "1,518",
      color: "#90B1CE",
    },
    {
      title: "Unknown",
      percentage: "4.6%",
      number: "131",
      color: "#6D6D6D",
    },
  ];

  return (
    <Fragment>
      <Box>
        <Box>
          <p
            style={{
              marginBottom: ".5rem",
              fontFamily: "Roboto Condensed, sans-serif",
            }}
          >
            Origin of samples above legal limit (%)
          </p>
        </Box>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent={{ xs: "start", sm: "flex-end", md: "space-between" }}
          marginLeft={{ xs: "0rem", sm: "9rem", md: "0rem" }}
          maxWidth="400px"
        >
          {data.map((d, idx) => {
            return (
              <Box
                m={{ xs: 1, sm: 1, md: 0 }}
                key={idx}
                sx={{
                  paddingLeft: ".5rem",
                  borderLeft: `3px ${d.color} solid`,
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    fontFamily: "Roboto Condensed, sans-serif",
                  }}
                >
                  {d.title}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    fontFamily: "Roboto Condensed, sans-serif",
                  }}
                >
                  <b>{d.percentage}</b>
                  <span style={{ paddingLeft: "5px", fontSize: "15px" }}>
                    ({d.number})
                  </span>
                </p>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Fragment>
  );
};

export default SampleOriginDistribution;
